/**
 * Formats a numeric emission value to a string with a specified number of decimal places.
 *
 * @param value - The emission value to format.
 * @param digits - The number of decimal places to include in the formatted string. Defaults to 6.
 * @returns The formatted emission value as a string with the specified number of decimal places.
 */
export const emissionValueWithDecimals = (value?: number, digits = 6): string => {
  if (value == null) {
    return '';
  }

  const formattedValue = value.toFixed(digits);

  // Remove the last trailing zeros after the decimal point
  return formattedValue.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
};
